import { Trans, useTranslation } from 'react-i18next';
import { Anchor, Text } from '@mantine/core';

import { Modal, Props as ModalProps } from 'components/shared/Modals/Modal';
import { STATIC_URLS } from '../../../../consts';

type Props = Omit<ModalProps, 'children'> & {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
};

export const PrivacyDataModal = ({
  isOpen,
  onClose,
  onSubmit,
  ...restModalProps
}: Props) => {
  const { t } = useTranslation('user');

  return (
    <Modal
      title={t('user:privacyDataModal.header')}
      isOpen={isOpen}
      onClose={onClose}
      primaryButtonAction={onSubmit}
      {...restModalProps}
    >
      <Text size="sm">
        <Trans
          i18nKey="user:privacyDataModal.content"
          components={{
            a: <Anchor href={STATIC_URLS.privacyPolicy} target="_blank" />,
          }}
        />
      </Text>
    </Modal>
  );
};
